import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../helper/api";

export const fetchUserBalance = createAsyncThunk(
  "fetchUserBalance/fetchUserBalance",
  async (payload, thunkAPI) => {
    try {
      const response = await api.get("user-balance");
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue("Something went wrong");
    }
  }
);

const fetchUserBalanceSlice = createSlice({
  name: "fetchUserBalance",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },

  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserBalance.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchUserBalance.fulfilled, (state, action) => {
          
          
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchUserBalance.rejected, (state, action) => {
        
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default fetchUserBalanceSlice.reducer;
